/* eslint camelcase: "off" */

import { playLoad, playDo } from 'amkit3-modules/utils/services/statistic/playstats'
import { webduowanvideoload, webduowanvideo } from 'amkit3-modules/utils/services/statistic/hiido'
import { getOneTime } from 'amkit3-modules/utils/services/statistic/onetime'
/** 下掉海度统计 */
// import pas from 'amkit3-modules/utils/services/statistic/pas'
import ya from 'amkit3-modules/utils/services/statistic/ya2'
import { video_quality_kadun } from 'amkit3-modules/utils/services/statistic/huya/metric'

import requestAniFrame from 'amkit3-modules/utils/raf'

import StatisticEvent from './statistic-event'

class PlayStatistic {
  constructor(collector) {
    this.playTimes = {}
    this.playTimesKeyLength = Object.keys(this.playTimes).length
    let pro = 'huyasp' + (process.env.NODE_ENV === 'development' || process.env.TEST ? '_test' : '')
    var pasDelegate = (func, dur, props) => {
      func(
        dur,
        pro,
        collector.getSessionId(),
        'live',
        collector.getMId(),
        collector.getYYUId(),
        collector.getPas(),
        'YY',
        1,
        1,
        collector.getVid(),
        window.location.href,
        0,
        window.location.href,
        document.referrer,
        'zh-cn',
        collector.getOS(),
        collector.getSre(),
        'web',
        new Date().valueOf(),
        props,
      )
    }

    collector.on(StatisticEvent.PLAYER_LOAD, () => {
      playLoad(
        collector.getVid(),
        'web',
        collector.getChannelId(),
        window.location.href,
        document.referrer,
        collector.getLaiyuanv3(),
      )
      webduowanvideoload(
        collector.getVid(),
        collector.getVname(),
        collector.getChannelId(),
        '',
        window.location.href,
        document.referrer,
        new Date().valueOf(),
        collector.getLaiyuanv3(),
      )
    })
    collector.on(StatisticEvent.PLAYER_PLAY, () => {
      playDo(
        collector.getVid(),
        'web',
        collector.getChannelId(),
        window.location.href,
        document.referrer,
        collector.getLaiyuanv3(),
      )
      webduowanvideo(
        collector.getVid(),
        collector.getVname(),
        collector.getChannelId(),
        '',
        window.location.href,
        document.referrer,
        new Date().valueOf(),
        collector.getLaiyuanv3(),
      )
      // pasDelegate(pas.hysp_videoplay_vv_web, '')
      pasDelegate(ya.hysp_videoplay_vv_web, '')
    })
    collector.on(StatisticEvent.TIME_UPDATE, () => {
      let currentTime = Math.floor(collector.getCurrentTime())
      if (!isNaN(currentTime) && currentTime !== this.lastCurrentTime) {
        this.playTimes[String(currentTime)] = true
      }
      this.lastCurrentTime = currentTime
    })
    collector.on(StatisticEvent.PLAYBACK_PROGRESS_ERROR, () => {
      // pasDelegate(pas.hysp_videoplay_errortimes, '')
      pasDelegate(ya.hysp_videoplay_errortimes, '')
    })
    collector.on(StatisticEvent.PLAYBACK_LAGGING, () => {
      // pasDelegate(pas.hysp_videoplay_badtimes, '')
      pasDelegate(ya.hysp_videoplay_badtimes, '')
      video_quality_kadun(
        collector.getYYUId(),
        collector.getSessionId(),
        collector.getMId(),
        collector.getVid(),
        global.location.href,
        '0',
        collector.getCDNURL(),
        collector.getOS(),
        collector.getSre(),
        'kadun',
        collector.getCDN(),
        '',
      )
    })

    let reportFn = (dur = 0) => {
      const props = {
        vid: collector.getVid(),
        activity: 0,
        autoplay: 0,
        scene: 0,
        duration: dur * 1000,
        onetime: getOneTime(collector.getVid()),
      }
      pasDelegate(ya.hysp_videoplay_PlayTimeLength_web, String(dur * 1000), JSON.stringify(props))
    }
    let curTime = Date.now()
    let isFirst = true
    let playTimeStatis = () => {
      let nextTime = Date.now()
      if (isFirst && Object.keys(this.playTimes).length > 3) {
        //首次上报
        reportFn(0)
        isFirst = false
      }
      if (nextTime - curTime >= 5000) {
        curTime = nextTime
        let dur = Object.keys(this.playTimes).length - this.playTimesKeyLength
        this.playTimes = {}
        this.playTimesKeyLength = Object.keys(this.playTimes).length
        if (dur) {
          // pasDelegate(pas.hysp_videoplay_PlayTimeLength_web, String(dur))
          reportFn(dur)
        }
      }
      requestAniFrame(playTimeStatis)
    }

    playTimeStatis()

    // setInterval(() => {
    //   let dur = Object.keys(this.playTimes).length - this.playTimesKeyLength
    //   this.playTimes = {}
    //   this.playTimesKeyLength = Object.keys(this.playTimes).length
    //   if (dur) {
    //     // pasDelegate(pas.hysp_videoplay_PlayTimeLength_web, String(dur))
    //     pasDelegate(ya.hysp_videoplay_PlayTimeLength_web, String(dur))
    //   }
    // }, 5000)
  }
}

export default PlayStatistic
